import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import Input from '@src/components/inputs/Input'
import { css } from '@emotion/react'

const TitleForm = () => {
	const { getFieldProps } = useMyProductFormContext()
	return (
		<div>
			<Input
				{...getFieldProps('title')}
				wrapperStyle={css`
					margin-bottom: 1rem;
					flex-flow: column;
				`}
				css={css`
					box-sizing: border-box;
					width: 40rem;
				`}
				placeholder="상품명을 입력해주세요."
			/>
		</div>
	)
}

export default TitleForm
